<template>
    <div class="copy-plugin">
        <el-tooltip v-if="tips" effect="dark" :content="`鼠标单击即可复制${name}`" placement="top-start">
            <slot @click="copyText" />
        </el-tooltip>
        <div v-if="!tips" @click="copyText">
            <slot />
        </div>
    </div>
</template>

<script>
import {Toast} from "vant";
export default {
    name: 'copy-clipboard',
    data() {
        return {

        }
    },
    props: {
        text: {
            type: [String, Number],
            default: () => ''
        },
        name: {
            type: String,
            default: () => ''
        },
        tips: {
            type: Boolean,
            default: () => false
        },
    },
    mounted() {

    },
    methods: {
        copyText() {
            this.$copyText(('' + this.text).toString()).then(
                res => {
                    Toast.success(`复制${this.name}成功`);
                },
                err => {
                    Toast.error(`复制${this.name}失败`);
                }
            );
        }
    }
}
</script>

<style scoped>
.copy-plugin {
    display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/copyClipboard/index.vue